import type { ReactElement } from 'react';
import { render } from 'react-dom';
// eslint-disable-next-line jira/restricted/react-18
import { createRoot, hydrateRoot } from 'react-dom/client';
import { fg } from '@atlassian/jira-feature-gating';
import type { MatchedRoute } from '@atlassian/react-resource-router/src/common/types.tsx';
import { getIsConcurrentEnabled } from '@atlassian/jira-react-concurrent/src/utils/get-is-concurrent-enabled.tsx';
import { hydrationOptions } from './hydration-options.tsx';

export const renderReactApp = (
	children: ReactElement,
	{
		initRoute,
		container,
	}: {
		/**
		 * The route being rendered on initial page load - which can affect how React starts.
		 */
		initRoute: MatchedRoute | null;
		/**
		 * The container to render the React app into.
		 */
		container: HTMLElement;
	},
) => {
	if (initRoute?.route?.isHydrateRootEnabled || fg('jfp-magma-force-react-hydrate-root')) {
		// hydrateRoot also enables concurrent mode, if you enable hydration on your route. It's also assumed you want and understand concurrent mode.
		hydrateRoot(container, children, hydrationOptions);
	} else if (getIsConcurrentEnabled()) {
		// If the route is not enabled for hydration but concurrent mode is enabled for this environment, render in concurrent mode
		const root = createRoot(container);
		root.render(children);
	} else {
		// if the feature flag is false, do not opt into concurrent features
		// if the local env var is not set, or set to false, do not opt into concurrent features
		render(children, container);
	}
};
